const datePicker = {
  width: '100% ',
  marginBottom: '15px',
  marginRight: '15px',
};

export { datePicker };
